module.exports = __webpack_public_path__ + "img/invoiceRepaireAct.85716069.png";